import { client } from './api';

class UserService {
  getUserProfile = () => client.get('user/current');

  getUser = id => {
    const response = client.get(`user/${id}`);

    return response;
  };

  updateUserProfile = async data => {
    const response = await client.put('user/current', data);
    return response;
  };

  contactUs = async data => {
    const response = await client.post('Feedback', data);
    return response;
  };

  getLocations = async data => {
    const response = await client.get('Location', data);
    return response;
  };

  getCurrencies = async () => {
    const response = await client.get('Currency');
    return response;
  };

}

export default new UserService();
